import axios from './../index'

class menu {


    static addMenu(params) {
        return axios.post(`/app-admin/sys/menu/insert`,params)
    }
    
    static menuList(params) {
        return axios.get(`/app-admin/sys/menu/menu-tree-list`,{params:params})
    }
    static topMenuTree(params) {
        return axios.get(`/app-admin/sys/menu/top-menu-tree`,{params:params})
    }
    //编辑账号
    static menuEdit(params) {
        return axios.post(`/app-admin/sys/menu/update`,params)
    }

    //账号开关
    static switchState(adminId) {
        return axios.post(`/app-admin/sys/menu/switchState/${adminId}`)
    }

    //树形结果集合
    static menuListTree(params) {
        return axios.get(`/app-admin/sys/menu/select-menu-tree`,{params:params})
    }
    //查询头部目录
    static findTopLevelMenuList(params) {
        return axios.get(`/app-admin/sys/menu/find-top-level-menu`,{params:params})
    }
    //查询左侧菜单
    static findRouters(params) {
        return axios.get(`/app-admin/sys/menu/routers`,{params:params})
    }

}

export default menu;
